export default __webpack_public_path__ + "static/media/pequenas-empresas.d5605dfc.png";